import React from "react"
import Clickable from "@components/clickable"
import classnames from "@utils/classnames"

import * as styles from "./button.module.scss"

const Button = ({ className, hollow, ...props }) => {
  const classNames = classnames(
    styles.btn,
    { [styles.hollow]: hollow },
    "o_button",
    className
  )
  return <Clickable className={classNames} {...props} />
}

export default Button
